<template>
  <v-card class="project-changes-card">
    <v-card-title class="pb-3">
      Ostatnie zmiany
      <div class="project-changes-card__details">
        {{ projectChangesCountSuffix }}
      </div>
    </v-card-title>

    <v-card-text class="project-changes-card__content">
      <template v-if="history.changes.length">
        <div
          v-for="(change, i) in history.changes"
          :key="i"
          class="py-2"
        >
          <p
            class="text-subtitle-2"
            v-html="change.text"
          />
          <p class="text-10">
            {{ change.createdAt | timestamp }}
          </p>
        </div>
      </template>

      <AppEmptyState
        v-else
        title="Brak zmian"
        subtitle="W projekcie nie zostały wprowadzone żadne zmiany."
      />
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn
        text
        link
        small
        color="primary"
        :to="{ name: routeName }"
        :disabled="!history.changes.length"
      >
        Historia zmian
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import utils from '@/helpers/utils';
import AppEmptyState from '@/components/UI/AppEmptyState.vue';

export default {
  components: {
    AppEmptyState,
  },

  props: {
    history: {
      type: Object,
      required: true,
    },
    commercialPrint: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    projectChangesCountSuffix() {
      return utils.getCounterWithSuffix(this.history.total, 'zmiana', 'zmiany', 'zmiany');
    },
    routeName() {
      return this.commercialPrint ? 'commercial-print-changes' : 'project-changes';
    },
  },
};
</script>

<style lang="scss" scoped>
.project-changes-card {
  min-height: 354px;

  &__details {
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 0.5px;
    font-weight: 400;
  }
  &__content {
    min-height: calc(354px - 102px);
    display: flex;
    flex-direction: column;
  }
}
</style>
